module.exports = __webpack_public_path__ + "media/customizations/tradition/logo-6171b6d38c5823566afe299bee33a813.png";